































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ProgressDonut extends Vue {
  @Prop() percent!: number;
  get circle() {
    return Math.round(60 * Math.PI);
  }

  get offsetCircle() {
    return Math.round(this.circle * (this.percent / -100));
  }

  get colorForStatus() {
    let color: string = "green";
    if (this.percent <= 33) color = "#dc3545";
    if (this.percent > 33 && this.percent <= 66) color = "#ffc107";
    if (this.percent > 66) color = "#28a745";
    return color;
  }
}
